import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d64091f")

_pushScopeId("data-v-5d64091f")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "funteamclues__team-words-left center mt1"
}
const _hoisted_4 = { class: "funteamclues__team-players" }
const _hoisted_5 = { class: "my1 bold funteamclues__team-players-category" }
const _hoisted_6 = { class: "funteamclues__team-players-operatives" }
const _hoisted_7 = { class: "mt2 mb1 bold funteamclues__team-players-category" }
const _hoisted_8 = {
  key: 1,
  class: "funteamclues__team-players-choose-spy"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-wrap items-center mt2"
}
const _hoisted_10 = { class: "mt1" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { for: "email" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FunTeamCluesPlayer = _resolveComponent("FunTeamCluesPlayer")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["funteamclues__team", {
      red: $props.team.name === 'RED',
      blue: $props.team.name === 'BLUE',
      active: $props.team.name === $props.activeTeamName
    }]
    }, [
      _createVNode("div", {
        class: ["funteamclues__team-name center", { red: $props.team.name === 'RED', blue: $props.team.name === 'BLUE' }]
      }, [
        ($props.team.customName)
          ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString($props.team.customName) + " " + _toDisplayString(`(Team ${$props.team.name})`), 1))
          : (_openBlock(), _createBlock("span", _hoisted_2, "Team " + _toDisplayString($props.team.name), 1))
      ], 2),
      ($props.phase !== 'WELCOME')
        ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('funTeamClues.wordsLeft')) + _toDisplayString($setup.wordsLeft[$props.team.name]), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('funTeamClues.operatives')), 1),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.filteredPlayers.notSpy, (player) => {
            return (_openBlock(), _createBlock(_component_FunTeamCluesPlayer, {
              key: player.id,
              "show-change-spy": !$setup.filteredPlayers.spy && $props.phase === 'WELCOME',
              player: player,
              "current-player": $setup.currentPlayer,
              onChange: ($event: any) => ($setup.changeSpyStatus(player, $props.team))
            }, null, 8, ["show-change-spy", "player", "current-player", "onChange"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('funTeamClues.spy')), 1),
        ($setup.filteredPlayers.spy)
          ? (_openBlock(), _createBlock(_component_FunTeamCluesPlayer, {
              key: $setup.filteredPlayers.spy?.id,
              player: $setup.filteredPlayers.spy,
              "current-player": $setup.currentPlayer,
              "show-change-spy": $props.phase === 'WELCOME',
              onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeSpyStatus($setup.filteredPlayers.spy, $props.team, true)))
            }, null, 8, ["player", "current-player", "show-change-spy"]))
          : (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('funTeamClues.chooseOneSpy')), 1))
      ]),
      ($props.phase === 'WELCOME')
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            ($setup.showJoinTeam)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "m1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.joinTeam($props.team)))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('funTeamBidding.teams.join')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ($props.phase === 'WELCOME' && $setup.isPlayerInSpecificTeam($props.team))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "m1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.leaveTeam($props.team)))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('funTeamBidding.teams.leave')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_10, [
              ($props.phase === 'WELCOME' && $setup.isPlayerInSpecificTeam($props.team))
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openNewTeamModal($props.team.id)))
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('funTeamBidding.teams.changeName')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Dialog, {
      class: "funteamclues__teams-modal",
      visible: $setup.showNewTeamNameModal,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ($setup.showNewTeamNameModal = $event))
    }, {
      header: _withId(() => [
        _createVNode("h3", null, _toDisplayString(_ctx.$t('funTeamBidding.teams.changeName')), 1)
      ]),
      footer: _withId(() => [
        _createVNode(_component_BaseButtonWithSpinner, {
          disabled: !$setup.newTeamName,
          onClick: $setup.handleChangeNewTeamName,
          loading: $setup.newTeamNameLoading
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('funTeamBidding.teams.change')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick", "loading"])
      ]),
      default: _withId(() => [
        _createVNode("span", _hoisted_11, [
          _createVNode(_component_Input, {
            id: "email",
            type: "text",
            autofocus: "",
            modelValue: $setup.newTeamName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($setup.newTeamName = $event)),
            onKeyup: _withKeys($setup.handleChangeNewTeamName, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"]),
          _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('funTeamBidding.teams.newName')), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
})